var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#FFAC62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C10.5 8.89687 11.3969 8 12.5 8H13.5C14.6031 8 15.5 8.89687 15.5 10V10.1125C15.5 10.7938 15.1531 11.4281 14.5813 11.7937L13.2625 12.6406C12.475 13.1469 12 14.0188 12 14.9531V15C12 15.5531 12.4469 16 13 16C13.5531 16 14 15.5531 14 15V14.9563C14 14.7 14.1312 14.4625 14.3438 14.325L15.6625 13.4781C16.8062 12.7406 17.5 11.475 17.5 10.1125V10C17.5 7.79063 15.7094 6 13.5 6H12.5C10.2906 6 8.5 7.79063 8.5 10C8.5 10.5531 8.94687 11 9.5 11C10.0531 11 10.5 10.5531 10.5 10ZM13 20C13.3315 20 13.6495 19.8683 13.8839 19.6339C14.1183 19.3995 14.25 19.0815 14.25 18.75C14.25 18.4185 14.1183 18.1005 13.8839 17.8661C13.6495 17.6317 13.3315 17.5 13 17.5C12.6685 17.5 12.3505 17.6317 12.1161 17.8661C11.8817 18.1005 11.75 18.4185 11.75 18.75C11.75 19.0815 11.8817 19.3995 12.1161 19.6339C12.3505 19.8683 12.6685 20 13 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e082fff7204cabdd0f74dea2ebf47748.svg";
export { ForwardRef as ReactComponent };